export default __webpack_public_path__ + "images/8ea76c917fd4766af4af37142a4ebc1f-singersongwriter.webp";